import isEqual from 'lodash/isEqual';
import { EffectCallback, useEffect, useRef } from 'react';

/**
 * @description A custom hook that allows you to run an effect only when a specific dependencies change. All the dependencies will still
 *   remain up to date.
 *
 * @param effect The action to execute when the triggerValues change
 * @param allDependencies ALL the dependencies of your effect (including the triggers)
 * @param triggerValues The values that will trigger the effect when they change (they must also be in allDependencies)
 */
export function useSelectiveEffect(
  effect: EffectCallback,
  allDependencies: any[],
  triggerValues: any[],
) {
  const oldTriggerValuesRef = useRef<any[] | undefined>(undefined);
  const destructorRef = useRef<ReturnType<EffectCallback>>(undefined);

  useEffect(() => {
    if (!isEqual(oldTriggerValuesRef.current, triggerValues)) {
      oldTriggerValuesRef.current = triggerValues;
      destructorRef.current = effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effect, ...allDependencies]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => destructorRef.current, triggerValues);
}
